import { TenantId } from './tenant';

export * from './tenant';
export * from './theme';

/**
 * A type that extends a given type with a tenantId property.
 * @example
 * type MyComponentProps = PropsWithTenantId<{
 *   name: string;
 * }>;
 *
 * const MyComponent = (props: MyComponentProps) => {
 *   return <div>{props.tenantId}</div>;
 * };
 *
 * const myComponentProps: MyComponentProps = {
 *   tenantId: 'zoocasa',
 *   name: 'Potato',
 * };
 */
export type PropsWithTenantId<P = unknown> = P & { tenantId: TenantId };